import { Route, Switch, Redirect } from "wouter";
import { useSession } from "@/lib/auth-client";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { LoginPage } from "@/pages/LoginPage";
import { DashboardPage } from "@/pages/DashboardPage";
import { ChatsPage } from "@/pages/ChatsPage";
import { ChatPage } from "@/pages/ChatPage";
import { AlertsPage } from "@/pages/AlertsPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { RegisterPage } from "@/pages/RegisterPage";
import { NotesPage } from "@/pages/NotesPage";
import { TeamPage } from "@/pages/TeamPage";

function ProtectedRoute({ children }: { children: React.ReactNode }) {
	const { data: session, isPending } = useSession();

	if (isPending) {
		return (
			<div className="min-h-screen flex items-center justify-center bg-background">
				<div className="animate-pulse text-muted-foreground">Loading...</div>
			</div>
		);
	}

	if (!session?.session) {
		return <Redirect to="/login" />;
	}

	return <DashboardLayout>{children}</DashboardLayout>;
}

export function Router() {
	return (
		<Switch>
			<Route path="/login">
				<LoginPage />
			</Route>
			<Route path="/register">
				<RegisterPage />
			</Route>

			<Route path="/">
				<ProtectedRoute>
					<DashboardPage />
				</ProtectedRoute>
			</Route>

			<Route path="/chats">
				<ProtectedRoute>
					<ChatsPage />
				</ProtectedRoute>
			</Route>

			<Route path="/chats/:id">
				{(params) => (
					<ProtectedRoute>
						<ChatPage id={params.id} />
					</ProtectedRoute>
				)}
			</Route>

			<Route path="/alerts">
				<ProtectedRoute>
					<AlertsPage />
				</ProtectedRoute>
			</Route>

			<Route path="/notes">
				<ProtectedRoute>
					<NotesPage />
				</ProtectedRoute>
			</Route>

			<Route path="/settings">
				<ProtectedRoute>
					<SettingsPage />
				</ProtectedRoute>
			</Route>

			<Route path="/settings/team">
				<ProtectedRoute>
					<TeamPage />
				</ProtectedRoute>
			</Route>

			<Route>
				<Redirect to="/" />
			</Route>
		</Switch>
	);
}
